import React from "react";
import T from "prop-types";
import { useAuthProvider } from "2g-auth";

function Authorized({ children, roles }) {
  const { userInfo } = useAuthProvider();
  return userInfo.isUserInRole(roles) ? children : null;
}

Authorized.propTypes = {
  children: T.any,
  roles: T.array.isRequired
};

export default React.memo(Authorized);
